import script from "./CheckboxItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxItem.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxItem.vue?vue&type=style&index=0&id=4a4c4350&lang=scss"

const __exports__ = script;

export default __exports__